import React, { useState } from 'react';
import FileExplorer, { FileNode } from '../FileExplorer';
import CodeEditor from '../CodeEditor';
import { Permissions } from '../../constants';

export interface CodebasePanelProps {
  projectId: string;
  onClose: () => void;
  permissions?: string[];
  initialSelectedFile?: string | null;
  onInitialFileSelected?: () => void;
  isDevelopmentInProgress?: boolean;
}

const CodebasePanel: React.FC<CodebasePanelProps> = ({ projectId, onClose, permissions, initialSelectedFile, onInitialFileSelected, isDevelopmentInProgress = false }) => {
  const [selectedFile, setSelectedFile] = useState<FileNode | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(false);
  const [editorRefreshTrigger, setEditorRefreshTrigger] = useState(false);
  const hasUpdatePermission = permissions?.includes(Permissions.UpdateProjectPermission);

  const handleFileSelect = (file: FileNode) => {
    setSelectedFile(file);
  };

  const handlePanelClose = () => {
    // Close button always closes the entire panel
    onClose();
  };

  const handleFileSave = () => {
    // Trigger refresh of file explorer after save
    setRefreshTrigger(prev => !prev);
  };

  const handlePullComplete = () => {
    // Trigger refresh of code editor after pull
    setEditorRefreshTrigger(prev => !prev);
  };

  return (
    <div className="flex flex-row h-full w-full overflow-hidden bg-bg-primary">
      {/* File Explorer - Left Side */}
      <FileExplorer
        projectId={projectId}
        onFileSelect={handleFileSelect}
        selectedFile={selectedFile?.path}
        refreshTrigger={refreshTrigger}
        initialSelectedFile={initialSelectedFile}
        onInitialFileSelected={onInitialFileSelected}
        isDevelopmentInProgress={isDevelopmentInProgress}
        readOnly={!hasUpdatePermission}
        onPullComplete={handlePullComplete}
      />

      {/* Code Editor - Right Side */}
      <CodeEditor
        file={selectedFile}
        projectId={projectId}
        onFileSave={handleFileSave}
        onFileClose={handlePanelClose}
        readOnly={!hasUpdatePermission || isDevelopmentInProgress}
        isDevelopmentInProgress={isDevelopmentInProgress}
        refreshTrigger={editorRefreshTrigger}
      />
    </div>
  );
};

export default CodebasePanel;

